








































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import seoEntity from "@/entity/SeoEntity";
import SeoForm from "@/components/forms/SeoForm.vue";
@Component({components:{
        SeoForm
}})
export default class Seo extends Vue {
    @Prop({}) value!:number;
    @Prop({default:"12"}) md!:string;
    @Prop({}) label!:string;
    items:seoEntity[] = [];
    dialog:boolean=false;
    created(){
        this.get(true);
    }
    updateValue (value:string) {
        this.$emit('input', value)
    }
    success(){
        this.dialog = false;
        this.get(false,true);
    }
    async get(firstLoad:boolean = false ,selectLast:boolean = false){
        let response = await this.$http.get("seo");
        this.items = response.data;
        if(selectLast === true){
            let last = this.items[this.items.length - 1];
            this.value = last.seo_id;
        }
    }
    async add(){
        try{

        }catch (e) {
            alert(e.message);
        }
    }

}
